import React from 'react'
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import AcoesRemarcacaoCancelamento from './AcoesRemarcacaoCancelamento';


export default class Remarcacao extends React.Component {

    getBadgeVariant(situacao) {
        if (!situacao) return 'default';
        if (situacao === 'CONFIRMADO' || situacao === 'APROVADO') return 'confirmado';
        if (situacao === 'CANCELADO' || situacao === 'CANCELADO_REEMBOLSO_EFETUADO') return 'cancelado';
        if (situacao === 'PENDENTE') return 'pendente';
        if (situacao === 'REEMBOLSO_SOLICITADO') return 'reembolso';
        if (situacao === 'EM_ABERTO') return 'aberto';
        if (situacao === 'REMARCADO') return 'remarcado';
        return 'default';
    }

    getSituacaoLabel(situacao) {
        if (!situacao) return '-';
        return capitalizarTodasPrimeirasLetras(situacao.replace(/_/g, ' '));
    }

    exibirAcoes(reserva) {
        if (!reserva.sePodeRemarcarOuCancelar) {
            if (reserva.situacaoReserva === 'CANCELADO' || reserva.situacaoReserva === 'CANCELADO_REEMBOLSO_EFETUADO') {
                return <AcoesRemarcacaoCancelamento reserva={reserva}/>;
            }
        } else {
            if (reserva.situacaoReserva === 'REEMBOLSO_SOLICITADO') {
                return <AcoesRemarcacaoCancelamento reserva={reserva}/>;
            }
        }
        return <span style={{color: '#666', fontSize: '12px'}}>—</span>;
    }

    exibirMeta(reserva) {
        return (
            <div className="vx-remark-row-meta">
                <div className="vx-remark-meta-item"><strong>Pedido:</strong> {reserva.pedidoId}</div>
                <div className="vx-remark-meta-item"><strong>Itinerário:</strong> {reserva.itinerarioId}</div>
                <div className="vx-remark-meta-item"><strong>Rota:</strong> {reserva.idRota}</div>
                {reserva.responsavelEmbarque ? <div className="vx-remark-meta-item"><strong>Resp. Embarque:</strong> {reserva.responsavelEmbarque}</div> : ''}
                {reserva.responsavelDesembarque ? <div className="vx-remark-meta-item"><strong>Resp. Desembarque:</strong> {reserva.responsavelDesembarque}</div> : ''}
                {reserva.ultimoResponsavel ? <div className="vx-remark-meta-item"><strong>Último Resp.:</strong> {reserva.ultimoResponsavel}</div> : ''}
            </div>
        );
    }

    exibirReservas(reserva) {
        const badgeVariant = this.getBadgeVariant(reserva.situacaoReserva);
        const situacaoLabel = this.getSituacaoLabel(reserva.situacaoReserva);

        const mainContent = (
            <React.Fragment>
                <div className="vx-remark-row-main">
                    <div className="vx-remark-field">
                        <span className="vx-remark-field-label">Empresa</span>
                        <span className="vx-remark-field-value">{capitalizarTodasPrimeirasLetras(reserva.nomeEmpresa)}</span>
                    </div>
                    <div className="vx-remark-field">
                        <span className="vx-remark-field-label">Passageiro</span>
                        <span className="vx-remark-field-value">{capitalizarTodasPrimeirasLetras(reserva.passageiroDto.nome)}</span>
                        <span className="vx-remark-field-sub">{reserva.passageiroDto.cpfPassageiro}</span>
                    </div>
                    <div className="vx-remark-field">
                        <span className="vx-remark-field-label">Embarque</span>
                        <span className="vx-remark-field-value">{reserva.dataHoraPartida ? reserva.dataHoraPartida : '—'}</span>
                        {reserva.dataHoraEmbarque
                            ? <span className="vx-remark-field-sub">Embarcou: {reserva.dataHoraEmbarque}</span>
                            : <span className="vx-remark-field-sub">Não embarcou</span>}
                    </div>
                    <div className="vx-remark-field">
                        <span className="vx-remark-field-label">Origem → Destino</span>
                        <span className="vx-remark-field-value">{reserva.descCidadeOrigem} → {reserva.descCidadeDestino}</span>
                        <span className="vx-remark-field-sub">{reserva.delimitacao}</span>
                    </div>
                    <div className="vx-remark-field">
                        <span className="vx-remark-field-label">Situação</span>
                        <span className={`vx-remark-badge vx-remark-badge--${badgeVariant}`}>{situacaoLabel}</span>
                    </div>
                    <div className="vx-remark-field">
                        <span className="vx-remark-field-label">Poltrona</span>
                        <span className="vx-remark-field-value">{reserva.numeroPoltrona}</span>
                    </div>
                    <div className="vx-remark-field">
                        {this.exibirAcoes(reserva)}
                    </div>
                </div>
                {this.exibirMeta(reserva)}
            </React.Fragment>
        );

        if (!reserva.sePodeRemarcarOuCancelar) {
            return (
                <div className="vx-remark-row vx-remark-row--done">
                    {mainContent}
                </div>
            );
        }

        return (
            <div
                className={`vx-remark-row vx-remark-row--clickable${reserva.selecionada ? ' vx-remark-row--selected' : ''}`}
                onClick={() => this.props.alterarMarcacaoReserva(reserva)}
            >
                {mainContent}
            </div>
        );
    }

    render() {
        if (!this.props.reserva) {
            return '';
        }
        const { reserva } = this.props;
        return (
            <div>
                {this.exibirReservas(reserva)}
            </div>
        );
    }
}
